var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-base-activity',{ref:"baseEdit",attrs:{"title":"Gestion du SEO","width":"900"}},[_c('edit-base-seo',{attrs:{"pageContent":_vm.activity.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }